/**
 * Conteo de pestañas Vault (tope 8): misma regla que sidebar / buscador global.
 * Base del módulo (`/layout/vault`) no cuenta.
 */

export interface VaultTabLike {
  id?: string | number;
  route?: string | null;
}

export function vaultTabRouteKey(route: string | null | undefined): string {
  if (!route) return '';
  return route
    .toLowerCase()
    .split('?')[0]
    .split('#')[0]
    .replace(/\/+$/, '');
}

export function isVaultModuleBaseRoute(route: string): boolean {
  const n = vaultTabRouteKey(route);
  return n === '/vault' || n === '/layout/vault';
}

export function countVaultOpenTabs(tabs: VaultTabLike[]): number {
  return tabs.filter((t) => {
    const route = (t.route || '').trim();
    if (!route && t.id == null) return false;
    return !isVaultModuleBaseRoute(route || String(t.id ?? ''));
  }).length;
}

export function normalizeVaultMenuRoute(route: string): string {
  if (!route) return '/layout/vault/dashboard';
  let clean = route.trim();
  if (clean.startsWith('/layout/vault/')) return clean;
  if (clean.startsWith('/admin/')) return `/layout/vault${clean}`;
  if (clean.startsWith('/vault')) return clean.replace('/vault', '/layout/vault');
  if (clean.startsWith('/layout/')) {
    return clean.replace(/^\/layout\/(accounting|tesorería|budget)\//, '/layout/vault/');
  }
  if (clean.startsWith('/')) return `/layout/vault${clean}`;
  return `/layout/vault/${clean}`;
}

export function findOpenVaultTab<T extends VaultTabLike>(
  tabs: T[],
  finalRoute: string,
): T | undefined {
  const target = vaultTabRouteKey(finalRoute);
  return tabs.find((t) => {
    const tabRoute = (t.route || '').trim();
    if (!tabRoute) return vaultTabRouteKey(String(t.id ?? '')) === target;
    return (
      vaultTabRouteKey(normalizeVaultMenuRoute(tabRoute)) === target ||
      vaultTabRouteKey(String(t.id ?? '')) === target
    );
  });
}
